import DropdownButton from '@shared/components/DropdownButton/DropdownButton';
import { DropdownSelectionProps } from '@shared/components/DropdownButton/DropdownSelection';
import Input from '@shared/components/InputGroup/Input';
import cx from 'classnames';
import { useMemo } from 'react';

import { ReactComponent as ArrowDown } from 'assets/icons/ArrowDown.svg';
import { getTimeZones } from 'modules/CreateNewRoomModal/CreateRoomStepModal/SchedulingToggleField/TimeZoneSelect/timezones';

export const getDefaultTimezone = (): number => Math.round(-(new Date().getTimezoneOffset() / 60));

interface TimezoneSelectProps {
  value: number;
  onChange: (tz: number) => void;
  name: string;
}

const TimezoneSelect = ({ value, onChange, name }: TimezoneSelectProps) => {
  const zones = useMemo(() => getTimeZones(), []);

  const selectedLabel = useMemo(
    () => zones.find((z) => z.timezone === value)?.title ?? `GMT ${value >= 0 ? '+' : ''}${value}`,
    [zones, value]
  );

  const options: DropdownSelectionProps[] = useMemo(
    () =>
      zones.map(({ timezone, title }) => ({
        title,
        isSelected: timezone === value,
        selectionClassName: timezone === value ? 'bg-gray-5' : undefined,
        onClick: () => onChange(timezone),
      })),
    [zones, value, onChange]
  );

  return (
    <DropdownButton
      id={name}
      className="max-h-60 h-full overflow-x-hidden overflow-y-scroll"
      options={options}
      placement="bottom-start"
      dropdownContainerClass="my-2.5 w-full !min-w-0"
      dropdownOffset={6}
    >
      {({ open }) => (
        <Input
          value={selectedLabel}
          variant="white-bg"
          className="truncate cursor-pointer text-gray-80"
          containerClassName={cx('!border-gray-20', { '!border-primary-50 !ring-gray-30 !ring-4': open })}
          iconClassName={cx('stroke-1 h-5 w-5 stroke-current cursor-pointer', { 'rotate-180': open })}
          icon={ArrowDown}
          autoComplete="off"
          readOnly
        />
      )}
    </DropdownButton>
  );
};

export default TimezoneSelect;
